export function timeToMinutes(timeString: string): number {
  // "HH:mm:ss" or "HH:mm" 形式
  const match = timeString.match(/^(\d{1,2}):(\d{2})/)
  if (match) {
    return parseInt(match[1], 10) * 60 + parseInt(match[2], 10)
  }
  // ISO形式 "2026-03-27T08:30:00" のフォールバック
  const date = new Date(timeString)
  return date.getHours() * 60 + date.getMinutes()
}

export function minutesToPx(minutes: number, pxPerMinute: number): number {
  return minutes * pxPerMinute
}

export function getInitialScrollTop(now: Date, pxPerMinute: number): number {
  const targetMinutes = Math.max(0, now.getHours() * 60 + now.getMinutes() - 60)
  return targetMinutes * pxPerMinute
}

export function formatTime(minutes: number): string {
  const h = String(Math.floor(minutes / 60)).padStart(2, '0')
  const m = String(minutes % 60).padStart(2, '0')
  return `${h}:${m}`
}
